// types
export const Types = {
  REQUEST_CONTACT_FORM: "REQUEST_CONTACT_FORM"
};

export function createContact(parameters) {
  return { type: Types.REQUEST_CONTACT_FORM, payload: parameters };
}
